module.exports = __webpack_public_path__ + "122301219327c7f80eb43414571efe27.svg";